<template>
  <div>
    <SearchComponent
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
      :cell-style="cellStyle"
    >
      <template slot="statusText" slot-scope="scope">
        <el-tag :type="scope.data.statusTextColor">{{ scope.data.statusText }}</el-tag>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-button
          :disabled="![2].includes(scope.data.status)"
          @click="onOperat('edit', scope.data)"
          type="text"
          v-hasPermi="[authIdentity + ':edit']"
          size="small"
          class="button"
        >修改</el-button>
        <el-button
          class="button"
          v-hasPermi="[authIdentity + ':detail']"
          type="text"
          size="small"
          @click="toDetail(scope.data)"
        >详情</el-button>
        <el-button
          v-if="[2].includes(scope.data.status)"
          v-hasPermi="[authIdentity + ':del']"
          @click="onOperat('cancel', scope.data)"
          type="text"
          size="small"
          class="button"
        >取消任务</el-button>
        <!-- <el-dropdown style="margin-left:10px">
            <i class="el-icon-more"></i>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(dropdown, index) in operateMore"
                :disabled="fundisabled(dropdown, scope.data)"
                @click.native="dropdown.click(scope.data)"
                :key="index"
                :icon="'el-icon-ht-'+dropdown.auth"
              >{{ dropdown.label }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>-->
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="operatDialog.title"
      :visible.sync="operatDialog.visible"
      :width="operatDialog.width"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="cancel"
    >
      <component
        :ref="operatDialog.currentView"
        :is="operatDialog.currentView"
        :data="operatDialog.data"
        :type="operatDialog.type"
      ></component>
      <span slot="footer">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import MForm from '@/views/pick/taskPick/components/form'
import Preview from '@/views/pick/taskPick/components/Preview'
import CancelForm from './components/CancelForm.vue'

import { getDropPlantationList } from '@/api/manage/plantation'
import { dictDataList } from '@/api/system/dict'
import { getPickTaskList, cancelPickTask } from '@/api/manage/picking-batch-task'
import { getDropFactoryList } from '@/api/system/manage'

import STATUS from '@/utils/statusConstants'

import { isDef } from '@/utils/is'
export default {
  name: 'TaskPick',
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    MForm,
    Preview,
    CancelForm,
  },
  data() {
    const _this = this
    const title = '采摘任务'
    return {
      authIdentity: 'pick:taskPick',
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'pickingBatchBizNo',
          label: '采摘批次',
          isTrue: true,
          width: 120,
        },
        {
          prop: 'customerName',
          label: '客户',
          isTrue: true,
          width: 120,
        },
        {
          prop: 'pickingDateTime',
          label: '采摘日期',
          isTrue: true,
          width: '100',
          formatter(row) {
            return _this.parseTime(row.pickingDateTime, '{y}-{m}-{d}')
          },
        },
        {
          prop: 'supervisor',
          label: '监园人员',
          isTrue: true,
          width: 110,
        },
        {
          prop: 'plantationBizNo',
          label: '果园编号',
          isTrue: true,
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
          width: 160,
        },
        {
          prop: 'cropBrandKeyValue',
          label: '产品名称',
          isTrue: true,
        },
        {
          prop: '',
          label: '规格',
          isTrue: true,
          width: 150,
          formatter(row) {
            const arr = [
              row.ripenessLevelSpecAttrValueKey,
              row.locDetails?.slice(row.locDetails?.lastIndexOf(',') + 1),
              row.cultivationMethodSpecValueKey,
            ]

            return arr.filter((item) => !!item).join('-')
          },
        },
        {
          prop: '',
          label: '计划采摘',
          isTrue: true,
          children: [
            {
              prop: 'planToPickTotalQuantity',
              label: '总筐数',
              isTrue: true,
            },
            {
              prop: 'plannedNetWeightPerUnit',
              label: '单筐净重(斤)',
              isTrue: true,
            },
            {
              prop: 'planToPickTotalNetWeight',
              label: '总净重(斤)',
              isTrue: true,
            },
          ],
        },
        {
          prop: '实际采摘',
          label: '实际采摘',
          isTrue: true,
          children: [
            {
              prop: 'actualTotalQuantity',
              label: '满筐总筐数',
              isTrue: true,
            },
            {
              prop: 'plannedNetWeightPerUnit',
              label: '单筐净重(斤)',
              isTrue: true,
            },
      
            {
              prop: 'actualTotalNetWeight',
              label: '总净重(斤)',
              isTrue: true,
            },
          ],
        },
        {
          prop: 'processFactoryName',
          label: '加工厂',
          isTrue: true,
          width: '120',
        },
        {
          prop: 'distributeName',
          label: '派发人',
          isTrue: true,
          width: '90',
        },
        {
          prop: 'createTime',
          label: '派发日期',
          isTrue: true,
          width: '100',

          formatter(row) {
            return row.createTime ? _this.parseTime(row.createTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          prop: 'statusText',
          label: '状态',
          isTrue: true,
          width: '100',
          formSolt: true,
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'plantationId',
          placeholder: '请选择果园',
          value: 'id',
          label: 'name',
          list: [],
          type: 'select',
        },
        {
          model: 'day',
          placeholder: '请选择任务区间',
          value: 'value',
          label: 'label',
          list: [
            { value: 3, label: '三天内' },
            { value: 7, label: '一周内' },
          ],
          type: 'select',
        },
        {
          model: 'status',
          placeholder: '请选择状态',
          value: 'dictValue',
          label: 'dictLabel',
          list: [],
          type: 'select',
        },
        {
          model: 'pickingBatchBizNo',
          placeholder: '请输入批次',
          class: 'home',
          type: 'input',
        },
        {
          model: 'customerName',
          placeholder: '请选择客户',
          value: 'name',
          label: 'name',
          list: [],
          type: 'select',
        },
      ],

      // 弹窗数据
      operatDialog: {
        visible: false, // 是否展示
        title: '', // 弹窗标题
        currentView: null, //当前组件
        width: '', // 弹窗宽度
        type: '', // 提交类型
        data: {}, // 数据
      },

      // 弹窗枚举
      operatEnum: {
        add: () => {
          return {
            component: 'MForm',
            title: `新增${title}`,
            width: '75%',
          }
        },
        edit: () => {
          return {
            component: 'MForm',
            title: `修改${title}`,
            width: '60%',
          }
        },
        preview: () => {
          return {
            component: 'Preview',
            title: `查看${title}`,
            width: '75%',
          }
        },
        resubmit: () => {
          return {
            component: 'MFrom',
            title: `重新提交${title}`,
            width: '75%',
          }
        },
        submit: () => {
          return {
            component: 'Preview',
            title: `提交${title}`,
            width: '75%',
          }
        },
        cancel: () => {
          return {
            component: 'CancelForm',
            title: `确定取消任务吗？取消后任务作废！`,
            width: '30%',
          }
        },
      },

      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
    }
  },
  mounted() {
    this.getPlantationList()
    this.getDictDataList()
    this.getCustomerList()
    this.getList()
  },
  methods: {
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getPickTaskList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              item.visible = false
              item.supervisor = JSON.parse(item.supervisorIdList || '[]')
                .map((item) => item.userName)
                .join(',')
              item.pickStatus = STATUS.pickStatus.find((s) => s.value == item.status).label
              item.statusText = STATUS.getStatusConversion(item.status, 'pickStatus')
              item.statusTextColor = STATUS.getStatusConversionColor(item.status, 'pickStatus')
              // item.visible = false
              // item.locName = this.formatLocal(item.locDetails, 3)
              // item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
              // item.statusText = CONSTANTS.getStatusConversion(item.status, 'taskStatus')
              // item.readyForHarvest = CONSTANTS.getStatusConversion(item.readyForHarvestStatus, 'readyForHarvestStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (
        isDef(row.planToPickTotalNetWeight) &&
        isDef(row.actualTotalNetWeight) &&
        row.planToPickTotalNetWeight !== row.actualTotalNetWeight &&
        [8, 9, 10, 11, 12, 13].includes(columnIndex)
      ) {
        return {
          background: '#feeaea',
          color: 'red',
        }
      }
    },
    getCustomerList() {
      getDropFactoryList({ type: 1 }).then((res) => {
        const item = this.selectOrInputList.find((i) => i.model === 'customerName')
        if (item) {
          item.list = res.data
        }
      })
    },
    getPlantationList() {
      getDropPlantationList().then((res) => {
        this.selectOrInputList[0].list = res.data.map((item) => {
          item.name = `${item.bizNo}-${item.name}`
          return item
        })
      })
    },
    getDictDataList() {
      dictDataList({
        dictType: 'pickTaskStatus',
      }).then((res) => {
        this.selectOrInputList[2].list = res.data.filter((item) => item.dictValue !== '1')
      })
    },
    toDetail({ id }) {
      this.$store.commit('manage/SET_INFO_DETAIL', { id })
      this.$router.push(`/taskPickDetail?id=${id}`)
    },
    // 操作: add添加，edit编辑，import导入, export导出, print打印
    onOperat(type, row) {
      // 添加操作类型
      const { component, title, width } = this.operatEnum[type]()
      this.operatDialog.title = title
      this.operatDialog.width = width
      this.operatDialog.type = type
      this.operatDialog.data = row || {}
      this.operatDialog.currentView = component
      this.operatDialog.visible = true
      this.$nextTick(() => {
        if (type == 'edit' && row) {
          this.$refs[this.operatDialog.currentView].getDetails(row)
        }
      })
    },
    submitFrom() {
      switch (this.operatDialog.type) {
        case 'edit':
          this.handleEditSubmit()
          break
        case 'cancel':
          this.handleCancelTaskSubmit()
          break
      }
    },
    async handleCancelTaskSubmit() {
      this.loading = true
      try {
        const form = await this.$refs[this.operatDialog.currentView].submit()

        let result = await cancelPickTask(form)
        if (result.code == 200 && result.flag) {
          this.$message.success('提交成功')
          this.onClose()
          this.getList()
        } else {
          this.$message.error(result.message)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    handleEditSubmit() {
      this.loading = true

      this.$refs[this.operatDialog.currentView]
        .submit()
        .then(() => {
          this.loading = false
          this.onClose()
          this.getList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 弹窗关闭
    onClose() {
      this.operatDialog.visible = false
      this.operatDialog.title = ''
      this.operatDialog.currentView = null
      this.operatDialog.data = {}
      this.operatDialog.type = ''
      this.operatDialog.width = ''
    },
    cancel() {
      if (this.loading) {
        return
      }
      this.operatDialog.visible = false
      // this.$refs[this.operatDialog.currentView].reset()
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '新增采购计划'
        this.currentView = 'MForm'
        this.type = 'add'
      })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang="less">
@import '~@/assets/tableList.less';
// @import '../../../../assets/form.less';
</style>
